// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"search__visuallyhidden--H7p5C","focusable":"search__focusable--IOLcA","button":"search__button--VolTG"};